// Bottom-right transient toast for success/error feedback after an action.
// `msg`: { type: 'success' | 'error', title?, text }. Auto-dismiss timing is the
// caller's responsibility (a `useEffect` + `setTimeout` calling `onDismiss`).
export function Toast({ msg, onDismiss }) {
  if (!msg) return null;
  return (
    <div className="fixed bottom-6 right-6 z-50 animate-toast-in">
      <div className="flex w-[22rem] max-w-[calc(100vw-3rem)] items-start gap-3 rounded-2xl bg-white/90 px-4 py-3.5 shadow-xl ring-1 ring-slate-900/5 backdrop-blur-xl dark:bg-slate-800/90 dark:ring-white/10">
        <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${msg.type === 'error' ? 'bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-300' : 'bg-green-100 text-green-600 dark:bg-green-500/20 dark:text-green-300'}`}>
          {msg.type === 'error' ? (
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M10 6v5M10 14h.01" strokeLinecap="round" /></svg>
          ) : (
            <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M5 10.5l3.5 3.5L15 6.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
          )}
        </span>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-navy-800 dark:text-slate-100">
            {msg.title || (msg.type === 'error' ? 'Something went wrong' : 'Done')}
          </div>
          <div className="mt-0.5 text-xs leading-relaxed text-slate-500 dark:text-slate-400">{msg.text}</div>
        </div>
        <button type="button" onClick={onDismiss} aria-label="Dismiss" className="-mr-1 -mt-1 shrink-0 rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-white/10 dark:hover:text-slate-200">
          <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M5 5l10 10M15 5L5 15" strokeLinecap="round" /></svg>
        </button>
      </div>
    </div>
  );
}
